export const initLazyLoadFonts = () => {
    window.WebFontConfig = {
        google: {
            families: ['Noto Sans JP:100,200,300,400,500,600,700&display=swap'],
        },
        timeout: 2000,
    };

    appendWebFontScript();

    function appendWebFontScript() {
        const webFontScript = document.createElement('script');
        webFontScript.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
        webFontScript.type = 'text/javascript';
        webFontScript.async = 'true';
        webFontScript.defer = 'true';
        document.head.append(webFontScript);
    }
};
